import { useRef, useState } from "react";

export default function useScheduleDragDrop() {
  const [dragState, setDragState] = useState(null);
  const [dragOverKey, setDragOverKey] = useState("");
  const dragPayloadRef = useRef(null);

  function handleDragStart(e, payload) {
    setDragState(payload);
    dragPayloadRef.current = payload;

    try {
      const serialized = JSON.stringify(payload);

      e.dataTransfer.effectAllowed = "move";

      // Most reliable built-in drag payload type
      e.dataTransfer.setData("text/plain", serialized);

      // Keep this too in case browser supports it
      e.dataTransfer.setData("application/json", serialized);
    } catch {
      // ignore
    }
  }

  function handleDragEnd() {
    setDragState(null);
    setDragOverKey("");
    dragPayloadRef.current = null;
  }

  function clearDragState() {
    setDragState(null);
    setDragOverKey("");
    dragPayloadRef.current = null;
  }

  function readDropPayload(e) {
    let payload = dragPayloadRef.current || dragState;

    if (!payload) {
      try {
        const plain = e.dataTransfer.getData("text/plain");
        if (plain) {
          payload = JSON.parse(plain);
        }
      } catch {
        payload = null;
      }
    }

    if (!payload) {
      try {
        const json = e.dataTransfer.getData("application/json");
        if (json) {
          payload = JSON.parse(json);
        }
      } catch {
        payload = null;
      }
    }

    return payload;
  }

  return {
    dragState,
    dragOverKey,
    setDragOverKey,
    handleDragStart,
    handleDragEnd,
    clearDragState,
    readDropPayload,
  };
}